import { comments } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-3">
          用户口碑
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-12 max-w-xl mx-auto">
          真实用户评价，听听大家怎么说91免费看片平台
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {comments.map((comment, i) => (
            <div
              key={i}
              className={`bg-background-50 rounded-lg p-5 md:p-6 ${
                i === 4 ? 'md:col-span-2 md:max-w-md md:mx-auto md:w-full' : ''
              }`}
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-full overflow-hidden shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{comment.name}</p>
                  <p className="text-xs text-foreground-400">{comment.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {comment.content}
              </p>
              <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
                <span className="flex items-center gap-1 cursor-pointer">
                  <i className="ri-thumb-up-line"></i> 有用
                </span>
                <span className="cursor-pointer">回复</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}